import React, { useState, useEffect } from 'react'
import InviteHeader from './components/InviteHeader'
import InviteAnnoucementCard from './components/InviteAnnoucementCard'
import Invite from './components/Invite'
import InviteFooter from './components/InviteFooter'
import get from 'lodash/get'
import first from 'lodash/first'
import './share.scss'

import { getPropertyAnnouncementInvitation } from '../../services/announcement-invitation'

const initialInvitationState = {
  property_announcement: {
    images: [
      {
        large: {
          url: '',
        },
      },
    ],
  },
  user: {
    profile_image: {
      large: {
        url: '',
      },
    },
  },
}

const Share = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const invitationId = urlParams.get('id')

  const [invitation, setInvitation] = useState(initialInvitationState)

  useEffect(() => {
    getPropertyAnnouncementInvitation(invitationId)
      .then(({ invitation }) => {
        setInvitation(invitation)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [invitationId])

  const type = get(invitation, 'property_announcement.info.type')
  const bathrooms = get(invitation, 'property_announcement.info.bathrooms')
  const garage = get(invitation, 'property_announcement.info.car_slots')
  const rooms = get(invitation, 'property_announcement.info.rooms')
  const area = get(invitation, 'property_announcement.info.area')
  const state = get(invitation, 'property_announcement.address.state')
  const neighbourhood = get(invitation, 'property_announcement.address.neighbourhood')
  const rent = get(invitation, 'property_announcement.values.rent')
  const condo = get(invitation, 'property_announcement.values.condo')
  const other = get(invitation, 'property_announcement.values.other')
  const userName = get(invitation, 'user.name')
  const userProfile = get(invitation, 'user.profile_image')
  const userPropertyImage = get(invitation, 'property_announcement.images')

  const propertImage = first(userPropertyImage)
  const handleWithPropertyImage = get(propertImage, 'small.url')

  return (
    <div>
      <InviteHeader userImage={userProfile} userName={userName} />

      <div className='content'>
        <InviteAnnoucementCard
          landLordImage={userProfile}
          landLordName={userName}
          state={state}
          neighbourhood={neighbourhood}
          rent={rent}
          condo={condo}
          other={other}
          propertyImage={handleWithPropertyImage}
          typeHome={type === 'apartment' ? 'Apê' : 'Casa'}
          area={area}
          bathrooms={bathrooms}
          garage={garage}
          rooms={rooms}
        />

        <Invite invite={invitation} />

        <InviteFooter />
      </div>
    </div>
  )
}

export default Share
